import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M23.25 12H.75m10.5-10.5L.75 12l10.5 10.5"
    }, null, -1)
  ]));
}
const arrowLeft = { render };
export {
  arrowLeft as default,
  render
};
//# sourceMappingURL=arrow-left.svg.js.map
